module.exports = __webpack_public_path__ + "img/vatandas_oda.b4ec1853.svg";